// @ts-nocheck
import { UserFactory, Tracker } from "@relewise/client";
import Cookies from "js-cookie";
import getCompleteTheLookObject from "./relewise/completeTheLookObject";
import getProductsViewedAfterViewingProductObject from "./relewise/productsViewedAfterViewingProductObject";
import getPopularProducts from "./relewise/popularProducts";
import getPopularProductsPersonal from "./relewise/popularProductsPersonal";
import getPowerStepObject from "./relewise/powerStepObject";
import getFallbackPopularProducts from "./relewise/fallbackPopularProducts";
import getCartRecommendationsObject from "./relewise/cartRecommendationsObject";
import getTrackProductViewRequestObject from "./relewise/trackProductViewRequestObject";
import getTrackCartRequestObject from "./relewise/trackCartRequestObject";
import getPopularProductCategoryObject from "./relewise/popularProductCategoryObject";
import getPersonalProductCategoryObject from "./relewise/personalProductCateoryObject";
import getTrackProductCategoryViewRequestObject from "./relewise/productCategoryViewRequestObject";

const urls = {
  COLLECTION_API: "/collections/api",
  RELEWISE_STAGE_API: "https://stage01-api.relewise.com/7962b125-6725-4248-bc22-40a9a7716730/v1/",
  RELEWISE_PROD_API: "https://api.relewise.com/5c0f81e8-824e-4e42-9c3d-a294e0e4add2/v1/",
  RELEWISE_STAGE_API_KEY: "7962b125-6725-4248-bc22-40a9a7716730",
  RELEWISE_PROD_API_KEY: "5c0f81e8-824e-4e42-9c3d-a294e0e4add2",
};

const cookies = {
  SELECTED_LOCATION: "MOSMOSH_SELECTED_LOCATION",
  NEWSLETTER_SIGNED_UP: "NEWSLETTER_SIGNED_UP",
  RELEWISE_TEMPORARY_ID: "RELEWISE_TEMPORARY_ID",
};

const generateUuid = () => {
  let dt = new Date().getTime();
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    const r = (dt + Math.random() * 16) % 16 | 0;
    dt = Math.floor(dt / 16);
    return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
  });
};

const STAGING = window.location.host === "localhost:8000";

const constants = {
  RELEWISE_STAGE_KEY: "z9bQzNv3mG1*7h",
  RELEWISE_PROD_KEY: "CU^Xd71l^3xPn8",
};

interface EndpointType {
  CartRecommendations: string;
  ProductView: string;
  Cart: string;
  ProductsViewedAfterViewingProductRequest: string;
  PowerStep: string;
  CompleteTheLook: string;
  PopularProducts: string;
  PopularProductsPersonal: string;
  FallbackPopularProducts: string;
  PopularProductCategory: string;
  PersonalProductCategory: string;
  ProductCategoryView: string;
}

const endpoints: EndpointType = {
  CartRecommendations: "PurchasedWithMultipleProductsRequest",
  ProductView: "TrackProductViewRequest",
  Cart: "TrackCartRequest",
  ProductsViewedAfterViewingProductRequest: "ProductsViewedAfterViewingProductRequest",
  PowerStep: "PurchasedWithProductRequest",
  CompleteTheLook: "PurchasedWithProductRequest",
  PopularProducts: "PopularProductsRequest",
  PopularProductsPersonal: "PersonalProductRecommendationRequest",
  FallbackPopularProducts: "PopularProductsRequest",
  PopularProductCategory: "PopularProductCategoriesRecommendationRequest",
  PersonalProductCategory: "PersonalProductCategoryRecommendationRequest",
  ProductCategoryView: "TrackProductCategoryViewRequest",
};

export const assortments = {
  com: 223,
  de: 137,
  dk: 143,
  se: 152,
  no: 143,
  uk: 160,
};

let temporaryId = "";
let authenticatedId = window.mosmosh.user;

type triggers = keyof EndpointType;

export function relewiseTracker() {
  return new Tracker(urls.RELEWISE_PROD_API_KEY, constants.RELEWISE_PROD_KEY, {
    serverUrl: "https://api.relewise.com/",
  });
}

export function relewiseTrack(trigger, options = {}) {
  let payload = {};
  let object = {};

  payload[trigger] = {
    User: getUserObject(),
    Typename: trigger,
  };

  if (trigger === "ProductView") {
    object = getTrackProductViewRequestObject(options);
  } else if (trigger === "Cart") {
    object = getTrackCartRequestObject();
  } else if (trigger === "ProductCategoryView") {
    object = getTrackProductCategoryViewRequestObject(options);
  }

  object
    .then((response) => {
      Object.assign(payload[trigger], response);
      postDataObject(endpoints[trigger], payload);
    })
    .catch((error) => {
      console.log(error);
    });
}

export function relewiseRecommend(trigger: triggers, options = {}): Promise<Response> {
  let payload = {};

  switch (trigger) {
    case "ProductsViewedAfterViewingProductRequest":
      payload = getProductsViewedAfterViewingProductObject(options);
      break;
    case "CompleteTheLook":
      payload = getCompleteTheLookObject(options);
      break;
    case "PopularProducts":
      payload = getPopularProducts(options);
      break;
    case "PopularProductsPersonal":
      payload = getPopularProductsPersonal(options);
      break;
    case "PowerStep":
      payload = getPowerStepObject(options);
      break;
    case "FallbackPopularProducts":
      payload = getFallbackPopularProducts(options);
      break;
    case "CartRecommendations":
      payload = getCartRecommendationsObject(options);
      break;
    case "PersonalProductCategory":
      payload = getPersonalProductCategoryObject(options);
      break;
    case "PopularProductCategory":
      payload = getPopularProductCategoryObject(options);
      break;
    default:
      throw new Error(`Endpoint "${trigger}" is invalid.`);
  }

  return postDataObject(endpoints[trigger], payload);
}

export function getUserObject() {
  let marketingConsent = false;
  const cookieScriptConsent = Cookies.get('CookieScriptConsent');
  if (cookieScriptConsent) {
    const consent = JSON.parse(cookieScriptConsent);
    if (consent?.categories?.includes("targeting")) {
      marketingConsent = true;
    }
  }

  const urlParams = new URLSearchParams(window.location.search);
  const voyadoId = urlParams.get("voyado_user_id") || sessionStorage.getItem("voyado_user_id");

  if (urlParams.has("voyado_user_id") && urlParams.get("voyado_user_id").length) {
    sessionStorage.setItem("voyado_user_id", urlParams.get("voyado_user_id"));
  }

  const userobj = {
    ...(authenticatedId && { AuthenticatedId: authenticatedId }),
    ...(voyadoId && voyadoId.length && { Identifiers: { VoyadoId: voyadoId } }),
    classifications: { Country: Cookies.get(cookies.SELECTED_LOCATION) },
  };

  if (marketingConsent || (voyadoId && voyadoId.length)) {
    temporaryId = localStorage.getItem(cookies.RELEWISE_TEMPORARY_ID);

    if (!temporaryId) {
      temporaryId = generateUuid();
      localStorage.setItem(cookies.RELEWISE_TEMPORARY_ID, temporaryId);
    }

    return UserFactory.byTemporaryId(temporaryId, userobj);
  }

  return UserFactory.anonymous(userobj);
}

export function updateTemporaryId() {
  const user = getUserObject();

  const input = document.querySelector('input[name="attributes[__TemporaryId]"]');
  if (input && user?.temporaryId) {
    input.value = user.temporaryId || "";
  }
}

function postDataObject(endpoint, payload) {
  const RELEWISE_BASE_API = STAGING ? urls.RELEWISE_STAGE_API : urls.RELEWISE_PROD_API;
  const RELEWISE_KEY = STAGING ? constants.RELEWISE_STAGE_KEY : constants.RELEWISE_PROD_KEY;

  return fetch(RELEWISE_BASE_API + endpoint, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `APIKey ${RELEWISE_KEY}`,
    },
    body: JSON.stringify(payload),
    history: false,
    method: "POST",
  }).catch((error) => {
    console.log(error);
  });
}
